function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    width: 110px;\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

/* eslint-disable react-hooks/rules-of-hooks */
import React, { useState } from 'react';
import styled, { css, ThemeProvider, useTheme } from 'styled-components';
import { mediaSmDown } from "../../../theme/helpers/media";
import Flex from "../../Grid/Flex";
import Box from "../../Grid/Box";
import { EnumFavoriteStates } from "../types";
import { getTypographyFontStyle } from "../../../theme/selectors";
import { FAVORITE_AUTH_POPUP_TEST_ID, FAVORITE_ICON_TEST_ID, FAVORITE_AUTH_BUTTON_TEST_ID, FAVORITE_BTN_TEST_ID, NBSP } from "../constants";
import { defaultProductCardTheme, FavoriteSizes } from "../theme";
import HeartIcon from "../../Icon/Heart";
import HeartKomus from "../../Icon/HeartKomus";
import HeartIconFilled from "../../Icon/HeartFilled";
import HeartKomusFilled from "../../Icon/HeartKomusFilled";
var FavoriteAuthPopupWrapper = styled(Flex).attrs({
  center: true,
  middle: true,
  grow: true,
  'data-testid': FAVORITE_AUTH_BUTTON_TEST_ID
}).withConfig({
  displayName: "FavoriteButton__FavoriteAuthPopupWrapper",
  componentId: "sc-1x3jd84-0"
})(["height:100%;position:relative;& >:first-child{z-index:1;}"]);
var FavoriteAuthPopup = styled(Box).attrs(function (_ref) {
  var popupSize = _ref.popupSize,
      favorite = _ref.theme.favorite,
      _ref$align = _ref.align,
      align = _ref$align === void 0 ? 'right' : _ref$align;
  return {
    pl: align === 'right' ? favorite === null || favorite === void 0 ? void 0 : favorite.width[popupSize] : 2,
    pr: align === 'left' ? favorite === null || favorite === void 0 ? void 0 : favorite.height[popupSize] : 2,
    py: 3
  };
}).withConfig({
  displayName: "FavoriteButton__FavoriteAuthPopup",
  componentId: "sc-1x3jd84-1"
})(["box-sizing:border-box;position:absolute;", " ", " top:-6px;width:152px;white-space:normal;text-align:", ";opacity:0;pointer-events:none;transition:opacity 0.3s ease-in-out;", ";", " ", ""], function (_ref2) {
  var align = _ref2.align;
  return align === 'right' && 'left: -6px;';
}, function (_ref3) {
  var align = _ref3.align;
  return align === 'left' && 'right: -6px;';
}, function (_ref4) {
  var align = _ref4.align;
  return align;
}, getTypographyFontStyle(100), mediaSmDown(_templateObject()), function (_ref5) {
  var popupSize = _ref5.popupSize,
      favorite = _ref5.theme.favorite;
  return css(["border-radius:", "px;background-color:", ";color:", ";"], favorite.borderRadius[popupSize], favorite.hoverBgColor, favorite === null || favorite === void 0 ? void 0 : favorite.color);
});
var Wrapper = styled.div.withConfig({
  displayName: "FavoriteButton__Wrapper",
  componentId: "sc-1x3jd84-2"
})(["", " >:first-child:hover + ", "{opacity:1;pointer-events:all;}"], FavoriteAuthPopupWrapper, FavoriteAuthPopup);
export var FavoriteIcon = styled(HeartIcon).attrs(function (_ref6) {
  var isActive = _ref6.isActive,
      _ref6$size = _ref6.size,
      size = _ref6$size === void 0 ? FavoriteSizes.big : _ref6$size,
      favorite = _ref6.theme.favorite;
  return {
    width: favorite === null || favorite === void 0 ? void 0 : favorite.icon.width[size],
    height: favorite === null || favorite === void 0 ? void 0 : favorite.icon.height[size],
    as: isActive && HeartIconFilled,
    'data-testid': FAVORITE_ICON_TEST_ID
  };
}).withConfig({
  displayName: "FavoriteButton__FavoriteIcon",
  componentId: "sc-1x3jd84-3"
})(["z-index:2;"]);
export var FavoriteKomusIcon = styled(HeartKomus).attrs(function (_ref7) {
  var isActive = _ref7.isActive,
      _ref7$size = _ref7.size,
      size = _ref7$size === void 0 ? FavoriteSizes.big : _ref7$size,
      favorite = _ref7.theme.favorite;
  return {
    width: favorite === null || favorite === void 0 ? void 0 : favorite.icon.width[size],
    height: favorite === null || favorite === void 0 ? void 0 : favorite.icon.height[size],
    as: isActive && HeartKomusFilled,
    'data-testid': FAVORITE_ICON_TEST_ID
  };
}).withConfig({
  displayName: "FavoriteButton__FavoriteKomusIcon",
  componentId: "sc-1x3jd84-4"
})(["z-index:2;"]);
var defaultTextInfoPopup = "\u0412\u043E\u0439\u0434\u0438\u0442\u0435, \u0447\u0442\u043E\u0431\u044B \u0434\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u043B\u044E\u0431\u0438\u043C\u044B\u0439".concat(NBSP, "\u043F\u0440\u043E\u0434\u0443\u043A\u0442");

// Переместил состояние "избранных" в HOС на случай,
// если решим убрать обязательную авторизацию на фиче
var withFavouriteState = function withFavouriteState(_ref8) {
  var _EnumFavoriteStates$d;

  var _ref8$isActive = _ref8.isActive,
      isActive = _ref8$isActive === void 0 ? false : _ref8$isActive,
      _ref8$state = _ref8.state,
      state = _ref8$state === void 0 ? EnumFavoriteStates["default"] : _ref8$state,
      _ref8$textInfoPopup = _ref8.textInfoPopup,
      textInfoPopup = _ref8$textInfoPopup === void 0 ? defaultTextInfoPopup : _ref8$textInfoPopup,
      onFavoriteClick = _ref8.onFavoriteClick,
      _ref8$size = _ref8.size,
      size = _ref8$size === void 0 ? FavoriteSizes.big : _ref8$size,
      className = _ref8.className,
      _ref8$popupAlign = _ref8.popupAlign,
      popupAlign = _ref8$popupAlign === void 0 ? 'right' : _ref8$popupAlign,
      isKomus = _ref8.isKomus;

  /* eslint-disable react-hooks/rules-of-hooks */
  var theme = useTheme();

  var resultTheme = _objectSpread({}, defaultProductCardTheme, {
    favorite: _objectSpread({}, defaultProductCardTheme.favorite, {}, theme.favorite)
  });
  /* eslint-disable react-hooks/rules-of-hooks */


  var _useState = useState(isActive),
      _useState2 = _slicedToArray(_useState, 2),
      stateFavorite = _useState2[0],
      setStateFavorite = _useState2[1];

  var onClick = function onClick() {
    if (state === EnumFavoriteStates["default"]) {
      setStateFavorite(!stateFavorite);
    }

    if (onFavoriteClick) {
      onFavoriteClick(!stateFavorite);
    }
  };

  var ResultComponent = isKomus ? React.createElement(FavoriteKomusIcon, {
    isActive: stateFavorite,
    size: size,
    onClick: onClick
  }) : React.createElement(FavoriteIcon, {
    isActive: stateFavorite,
    size: size,
    onClick: onClick
  });
  return React.createElement(ThemeProvider, {
    theme: resultTheme
  }, React.createElement(Wrapper, {
    "data-testid": FAVORITE_BTN_TEST_ID,
    className: className
  }, (_EnumFavoriteStates$d = {}, _defineProperty(_EnumFavoriteStates$d, EnumFavoriteStates["default"], ResultComponent), _defineProperty(_EnumFavoriteStates$d, EnumFavoriteStates.unlogged, React.createElement(FavoriteAuthPopupWrapper, null, ResultComponent, textInfoPopup && React.createElement(FavoriteAuthPopup, {
    popupSize: size,
    "data-testid": FAVORITE_AUTH_POPUP_TEST_ID,
    align: popupAlign
  }, textInfoPopup))), _EnumFavoriteStates$d)[state]));
};

export default withFavouriteState;